import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Demo from "../components/Demo";
import Main from "../components/main/Main";
import Home from "../components/home/Home";
import Index from "../components/home/Index";
import Login from '../components/login/Login';
import AdminList from '../components/admin/AdminList';
import AdminEdit from '../components/admin/AdminEdit';
import RuleList from '../components/rule/RuleList'
import RuleEdit from '../components/rule/RuleEdit'
import GroupList from '../components/group/GroupList'
import GroupEdit from '../components/group/GroupEdit'
import CategoryList from '../components/category/CategoryList'
import QueueList from '@/components/queue/QueueList'
import QueueDelayList from '@/components/queue/QueueDelayList'
import GoodsList from '@/components/goods/GoodsList'
import GoodsEdit from '@/components/goods/GoodsEdit'
import Test from '@/components/test/Test'
import BatchEmail from '../components/batch/BatchEmail.vue'

Vue.use(Router)

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }


export default new Router({
  routes: [

    {
      path: '/',
      name: 'Page',
      redirect: {name: 'Home'}
    },
    {
      path: '/demo',
      name: 'Demo',
      component: Demo
    },
    {
      path: '/main',
      name: 'Main',
      component: Main,
      children: [
        {
          path: 'home',
          name: 'Home',
          component: Home
        },
        {
          path: 'index',
          name: "Index",
          component: Index
        },
        {
          path: "admin_list",
          name: "AdminList",
          component: AdminList
        },
        {
          path: "admin_edit",
          name: "AdminEdit",
          component: AdminEdit
        },
        {
          path: "rule_list",
          name: "RuleList",
          component: RuleList
        },
        {
          path: "rule_edit",
          name: "RuleEdit",
          component: RuleEdit
        },
        {
          path: "group_list",
          name: "GroupList",
          component: GroupList
        },
        {
          path: "group_edit",
          name: "GroupEdit",
          component: GroupEdit
        },
        {
          path: "category_list",
          name: "CategoryList",
          component: CategoryList
        },
        {
          path: "queue_list",
          name: "QueueList",
          component: QueueList
        },
        {
          path: "queue_delay_list",
          name: "QueueDelayList",
          component: QueueDelayList
        },
        {
          path: "test",
          name: "Test",
          component: Test
        },
        {
          path: "batch_email",
          name: "BatchEmail",
          component: BatchEmail
        },
        {
          path: "cms",
          name: "Cms",
          component: () => import('../components/cms.vue')
        },
        // {
        //   path:'article_edit',
        //   name:'ArticleEdit',
        //   component:()=>import('../components/article/ArticleEdit.vue')

        // },
        // {
        //   path:'article_list',
        //   name:'ArticleList',
        //   component:()=>import('../components/article/ArticleList.vue')

        // },
        // {
        //   path:'expand_edit',
        //   name:'ExpandEdit',
        //   component:()=>import('../components/category/ExpandEdit.vue')

        // },
        // {
        //   path:'expand_list',
        //   name:'ExpandList',
        //   component:()=>import('../components/category/ExpandList.vue')

        // },


        {
          path: "goods_list",
          name: "GoodsList",
          component: GoodsList
        },
        {
          path: "goods_edit",
          name: "GoodsEdit",
          component: GoodsEdit
        },
        {
          path: "pic_list",
          name: "PicList",
          component: () => import('../components/goods/PicList')
        },
        {
          path: "pic_edit",
          name: "PicEdit",
          component: () => import('../components/goods/PicEdit')
        },
        {
          path: 'brand_edit',
          name: 'BrandEdit',
          component: () => import('../components/setting/BrandEdit')
        },
        {
          path: 'hot_goods',
          name: 'hot_goods',
          component: () => import('../components/setting/HotGoods')
        },
        {
          path: 'special_goods',
          name: 'special_goods',
          component: () => import('../components/setting/SpecialGoods')
        },


      ]
    },
    {
      path: '/login',
      name: "Login",
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js